/** URL pannello staff (cil-admin-client). */
export const getCilAdminUrl = () =>
  process.env.REACT_APP_ADMIN_URL || 'https://admin-cil.cilassociazione.it';
